import { FontWeights } from '@fluentui/react';
export function getNavLinkStyles(props) {
    const { theme, isSelected } = props;
    const { semanticColors } = theme;
    const styles = {
        root: {
            color: isSelected ? semanticColors.bodyText : semanticColors.buttonText,
            fontWeight: isSelected ? FontWeights.semibold : FontWeights.regular,
        },
        icon: {
            color: isSelected ? theme.palette.themePrimary : semanticColors.bodyText,
        },
        iconContainer: {
            '::before': [
                {
                    borderRadius: theme.effects.roundedCorner4,
                },
            ],
        },
    };
    return styles;
}
//# sourceMappingURL=NavLink.styles.js.map